import { useMutation, useQueryClient } from "@tanstack/react-query";

import { postProjects, type SaveProjectRequest } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "Projects/Api/Queries/queryKeys";

export function useCreateProjectMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SaveProjectRequest) =>
      postProjects(request),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.all,
      });
    },
  });
}
